export default "__VITE_ASSET__CrzOhsc0__"